


















import { Component, Vue } from 'vue-property-decorator'

@Component
export default class LanguageSwitcher extends Vue {
    setLocale( locale: string, event: Event ): void {
        event.preventDefault()

        if ( this.$i18n.locale !== locale ) {
            this.$i18n.locale = locale
            const to = this.$router.resolve( { params: { locale } } )

            this.$router.push( to.location )
        }
    }
}
